// src/views/Users/Customers/Modal/AddProjectModal.jsx
import React, { useState, useEffect, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { globalConstants, modeConstants } from "../../constants";
import ActionsDataTable from "../DataTable/ActionsDataTable";
import { useNavigate } from "react-router-dom";
import ActivityModal from "./ActivityModal";
import { useDispatch, useSelector } from "react-redux";
import {
  activityActions,
  candidateActions,
  projectActions,
} from "../../redux/actions";
import InvoiceModal from "./InvoiceModal";
import InvoiceViewModal from "./InvoiceViewModal";
import { SCREENS_IDS } from "../../system";

export default function ViewAllActivitiesModal({ show, onHide, isRecallProjectCandidates = true }) {
  const initialGridState = {
    length: 10,
    pageNumber: 1,
    orderBy: "",
    filterQuery: null,
    search: null,
    filterExpression: globalConstants.FILTER_EXPRESSION,
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sortingInProgressRef = useRef(false);

  const [gridState, setGridState] = useState(initialGridState);
  const [defaultPage, setDefaultPage] = useState(initialGridState.pageNumber);

  // modal state
  const [mode, setMode] = useState(modeConstants.ADD_MODE);
  const [showActivityModal, setShowActivityModal] = useState(false);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [rowData, setRowData] = useState({ items: [], total: 0 });
  const [showInvoice, setShowInvoice] = useState(false);

  const allData = useSelector((s) => s.activityReducer.data);
  const candidateData = useSelector((s) => s.candidateReducer.formData);

  // tiny chip style that mimics your screenshot
  const StageChip = ({ value }) => (
    <span
      className="px-3 py-2"
      style={{
        fontSize: 14,
        color: "#444",
        display: "inline-block",
      }}
    >
      {value}
    </span>
  );

  // table columns (order mirrors the mock)
  const actions = 
    // Actions
    {
      name: "Actions",
      sortable: false,
      width: "170px",
      cell: (row) => (
        <div
          className="d-flex align-items-center gap-2"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            type="button"
            className="btn btn-sm btn-outline-primary"
            title="Edit"
            aria-label="Edit"
            onClick={() => {
              getRowData(row, modeConstants.UPDATE_MODE);
              setShowActivityModal(true);
            }}
          >
            <i className="bi bi-pencil" />
          </button>

          <button
            type="button"
            className="btn btn-sm btn-outline-success"
            title="View"
            aria-label="View"
            onClick={() => {
              getRowData(row, modeConstants.VIEW_MODE);
              setShowActivityModal(true);
            }}
          >
            <i className="bi bi-eye" />
          </button>
          {/* {row.status == "Accepted" && (
            <button
              type="button"
              className="btn btn-sm btn-outline-danger"
              title="View"
              aria-label="View"
              onClick={() => {
                getInvoice(row, modeConstants.UPDATE_MODE);
                setShowInvoiceModal(true);
              }}
            >
              <i className="bi bi-file-pdf" />
            </button>
          )} */}
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    };

  const getRowData = (row, nextMode) => {
    dispatch(activityActions.getActivityById(row.id));
    setMode(nextMode);
  };

  const getInvoice = (row, nextMode) => {
    dispatch(activityActions.getInvoiceByActivityId(row.id));
    setMode(nextMode);
  };

  const toggleStatus = (id) => {
    dispatch(activityActions.deleteActivityById(id, candidateData?.id));
  };

  const onSort = (sortedColumn, sortDirection) => {
    sortingInProgressRef.current = true;
    const columnDirection = sortDirection
      ? sortDirection.toUpperCase() // "ASC" | "DESC"
      : null;
    setDefaultPage(gridState.pageNumber);
    setGridState((prevState) => ({
      ...prevState,
      orderBy:
        columnDirection !== null ? `${sortedColumn} ${columnDirection}` : "",
    }));
  };

  const onChangePage = (pageNumber) => {
    if (!sortingInProgressRef.current) {
      setGridState((prevState) => ({
        ...prevState,
        pageNumber: pageNumber,
      }));
    }
  };

  const onChangeRowsPerPage = (newPerPage, pageNumber) => {
    setGridState((prevState) => ({
      ...prevState,
      length: newPerPage,
      pageNumber: pageNumber,
    }));
  };

  const getAll = () => {
    if (candidateData?.id) {
      dispatch(activityActions.getAllActivity(gridState, candidateData?.id));
    }
  };
  useEffect(() => {
    if (allData !== null) {
      setRowData(allData);
    }
    // eslint-disable-next-line
  }, [allData]);

  useEffect(() => {
    getAll();
    sortingInProgressRef.current = false;
    // eslint-disable-next-line
  }, [gridState, candidateData?.id]);

  useEffect(() => {
    dispatch(projectActions.getAllProjectList());
    dispatch(candidateActions.getAllCandidateList());
  }, []);

  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>
          {candidateData?.project?.company?.companyName +
            " - " +
            candidateData?.project?.positionName +
            " - " +
            candidateData?.name}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <ActivityModal
          show={showActivityModal}
          onHide={() => setShowActivityModal(false)}
          mode={mode}
          isRecallProjectCandidates = {isRecallProjectCandidates}
        />
        <InvoiceModal
          show={showInvoiceModal}
          onHide={() => setShowInvoiceModal(false)}
          mode={mode}
          setShowInvoice={setShowInvoice}
        />

        <InvoiceViewModal
          show={showInvoice}
          onHide={() => setShowInvoice(false)}
        />

        <ActionsDataTable
          actions={actions}
          data={rowData.items}
          pagination
          highlightOnHover
          striped
          responsive
          persistTableHead
          selectableRows
          selectableRowsHighlight
          selectableRowsVisibleOnly
          paginationServer
          onSort={onSort}
          gridState={gridState}
          paginationTotalRows={rowData.total}
          onChangeRowsPerPage={onChangeRowsPerPage}
          onChangePage={onChangePage}
          paginationDefaultPage={defaultPage}
          paginationResetDefaultPage
          setMode={setMode}
          setShowModal={setShowActivityModal}
          setGridState={setGridState}
          toggleStatus={toggleStatus}
          screenId={SCREENS_IDS.ACTIVITIES}
        />
      </Modal.Body>
    </Modal>
  );
}
